import { MarkaEklePage } from './../marka-ekle/marka-ekle';

import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { Ortak } from './../../../../providers/ortak';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';

/**
 * Generated class for the MarkaListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-marka-listesi',
  templateUrl: 'marka-listesi.html',
})
export class MarkaListesiPage {
  aranan="";
  skip:number=0;
  take:number=100;
  MarkaListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
    public act:ActionSheetController,
     public navParams: NavParams) {
  }


  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "MarkaListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.MarkaListesi = sonuc.SonucObject;
   
   
 
    })
  }
  
  markakayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(MarkaEklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(marka){
    let modal = this.modalCtrl.create(MarkaEklePage, { markaVw: marka });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  MarkaSil(marka) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();

      formData.append("ID", marka.ID);

      this.bllOrtak.islem(formData, "MarkaSil", "", true).then(a => {
        var sonuc = <any>a;
       if(sonuc.Sonuc==1)
       {
        this.ortak.showBasicAlert("Başarılı","Birim başarılı bir şekilde silinmiştir");
        this.kayitAra("");
       }
 
       if(sonuc.Sonuc==0)this.ortak.showBasicAlert("Uyarı","Birim bir ürüne kayıtlı olduğu için silinemedi");
       if(sonuc.Sonuc==99)console.log(sonuc.SonucObject);
      }).catch(x => {

        this.ortak.showErrorAlert();
      })
     
    })
   
  }
  Islemler(marka) {
    const actionSheet = this.act.create({
      title: marka.MarkName,
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.MarkaSil(marka);
          }

        },
        {
          text: 'Düzenle',
          handler: () => {
            this.kayitduzenle(marka);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/MarkaIslemleri/marka-listesi/marka-listesi.ts